import { ValueFormatterParams } from 'ag-grid-community';
import { format, isValid, parseISO } from 'date-fns';

import { DATE_FORMAT } from '@/constants';

export function dateFormatter(
  params: { value: string } | ValueFormatterParams<any, string>,
): string {
  const dateValue = params.value;
  if (!dateValue) {
    return '';
  }

  const date = parseISO(dateValue);
  if (!isValid(date)) {
    return '';
  }

  return format(date, DATE_FORMAT);
}
